/* Atlas footer (from ac-cat-v2): mobile accordion, run-club clocks, currency switcher. */
(function () {
  const footer = document.querySelector('[data-footer]');
  if (!footer) return;
  const $$ = (s, r) => Array.from((r || footer).querySelectorAll(s));

  /* Accordion: one group open at a time */
  const items = $$('[data-acc]');
  items.forEach((item) => {
    const btn = item.querySelector('[data-acc-toggle]');
    const links = item.querySelector('.af__acclinks');
    btn.addEventListener('click', () => {
      const open = btn.getAttribute('aria-expanded') === 'true';
      items.forEach((o) => {
        o.querySelector('[data-acc-toggle]').setAttribute('aria-expanded', 'false');
        o.querySelector('.af__acclinks').hidden = true;
      });
      if (!open) { btn.setAttribute('aria-expanded', 'true'); links.hidden = false; }
    });
  });

  /* Clocks (24h, en-GB), refreshed every 30s like the prototype */
  let clocks = [];
  try { clocks = JSON.parse(footer.dataset.clocks || '[]'); } catch (e) {}
  const grid = footer.querySelector('[data-clock-grid]');
  const inline = footer.querySelector('[data-clock-inline]');
  function time(tz) {
    try { return new Date().toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', timeZone: tz }); }
    catch (e) { return ''; }
  }
  function paint() {
    if (grid) {
      grid.innerHTML = clocks.map((c) =>
        '<span class="af__clock"><span class="af__clockcity"></span><span class="af__clocktime"></span></span>').join('');
      grid.querySelectorAll('.af__clock').forEach((el, i) => {
        el.children[0].textContent = clocks[i].city;
        el.children[1].textContent = time(clocks[i].tz);
      });
    }
    if (inline) {
      inline.innerHTML = clocks.map(() => '<span class="af__clockinl"><span></span><b></b></span>').join('');
      inline.querySelectorAll('.af__clockinl').forEach((el, i) => {
        el.children[0].textContent = clocks[i].city;
        el.children[1].textContent = time(clocks[i].tz);
      });
    }
  }
  paint();
  setInterval(paint, 30000);

  /* Region / currency dropdown (desktop) and inline list (mobile); selection handled by region.js */
  $$('[data-fcur-toggle]').forEach((btn) => {
    const scope = btn.closest('.af__curwrap') || btn.closest('.af__panel');
    const list = scope.querySelector('[data-fcur-list]');
    const caret = btn.querySelector('[data-caret]');
    btn.addEventListener('click', () => {
      list.hidden = !list.hidden;
      btn.setAttribute('aria-expanded', String(!list.hidden));
      if (caret) caret.textContent = list.hidden ? '▾' : '▴';
      if (!list.hidden) { const si = list.querySelector('[data-region-search]'); if (si) si.focus({ preventScroll: true }); }
    });
    document.addEventListener('click', (e) => {
      if (!scope.contains(e.target) && !list.hidden) {
        list.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        if (caret) caret.textContent = '▾';
      }
    });
  });
})();
